import { render, staticRenderFns } from "./ImportarProcesso.vue?vue&type=template&id=5f2d9f6d&scoped=true"
import script from "./ImportarProcesso.vue?vue&type=script&lang=js"
export * from "./ImportarProcesso.vue?vue&type=script&lang=js"
import style0 from "./ImportarProcesso.vue?vue&type=style&index=0&id=5f2d9f6d&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f2d9f6d",
  null
  
)

export default component.exports